var _rect, _rect2, _rect3, _path, _g, _rect4, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 49,
    viewBox: "0 0 66 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5283,
    width: 38.4805,
    height: 48.3243,
    rx: 10,
    fill: "#B1CBF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 11.6338,
    width: 20.5826,
    height: 24.1622,
    rx: 5,
    fill: "#7DA9E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9551,
    y: 10.6338,
    width: 22.5826,
    height: 26.1622,
    rx: 6,
    fill: "#2F75DA",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3624 29.4197V28.1519C15.3624 27.4794 15.0952 26.8345 14.6197 26.359C14.1442 25.8835 13.4993 25.6164 12.8268 25.6164H7.75575C7.08328 25.6164 6.43836 25.8835 5.96286 26.359C5.48735 26.8345 5.22021 27.4794 5.22021 28.1519V29.4197M12.8268 20.5453C12.8268 21.9456 11.6916 23.0808 10.2913 23.0808C8.89095 23.0808 7.75575 21.9456 7.75575 20.5453C7.75575 19.145 8.89095 18.0098 10.2913 18.0098C11.6916 18.0098 12.8268 19.145 12.8268 20.5453Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3079_13041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9676 19.7531C58.6629 19.4483 58.3011 19.2064 57.9029 19.0414C57.5047 18.8764 57.0779 18.7915 56.6469 18.7915C56.2158 18.7915 55.789 18.8764 55.3908 19.0414C54.9926 19.2064 54.6308 19.4483 54.3261 19.7531L53.6937 20.3855L53.0613 19.7531C52.4458 19.1376 51.611 18.7918 50.7405 18.7918C49.8701 18.7918 49.0353 19.1376 48.4198 19.7531C47.8043 20.3686 47.4585 21.2034 47.4585 22.0739C47.4585 22.9443 47.8043 23.7791 48.4198 24.3946L49.0522 25.027L53.6937 29.6685L58.3352 25.027L58.9676 24.3946C59.2725 24.0899 59.5143 23.7281 59.6793 23.3299C59.8443 22.9317 59.9292 22.5049 59.9292 22.0739C59.9292 21.6428 59.8443 21.216 59.6793 20.8178C59.5143 20.4196 59.2725 20.0578 58.9676 19.7531V19.7531Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1621,
    y: 18.793,
    width: 14.3183,
    height: 3.57958,
    rx: 1.78979,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1621,
    y: 27.7417,
    width: 10.7387,
    height: 3.57958,
    rx: 1.78979,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3079_13041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3183,
    height: 14.3183,
    fill: "white",
    transform: "translate(46.5347 17.0029)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalIcon);
export default __webpack_public_path__ + "static/media/clinicalIcon.363db6af890bef9b6e8ff3309c0039ab.svg";
export { ForwardRef as ReactComponent };